import { StringUtils } from 'src/app/services/utils/string.utils';
import { ProcessTableObject } from './process-table/process-table-object.model';
import { ProcessDetailsObject } from './process-details/process-details-object.model';
import { isNullOrUndefined } from 'util';

export class OrderDetailsProcessObject {

    private status: string;
    private fetched: boolean;

    constructor(private processId: string, private type: string, private name: string,
        status: string, private table: ProcessTableObject, private details: ProcessDetailsObject,
        fetched?: boolean) {

        this.status = status != null ? status.toUpperCase() : null;
        this.fetched = isNullOrUndefined(fetched) ? true : fetched;
    }

    public static create(): OrderDetailsProcessObject {
        return new OrderDetailsProcessObject(StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE,
            StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE, ProcessTableObject.create(), ProcessDetailsObject.create(), false);
    }

    public createWithTable(): OrderDetailsProcessObject {
        return new OrderDetailsProcessObject(StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE,
            StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE, ProcessTableObject.create(), ProcessDetailsObject.create(), false);
    }
    public createWithDetails(): OrderDetailsProcessObject {
        return new OrderDetailsProcessObject(StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE,
            StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE, ProcessTableObject.create(), ProcessDetailsObject.create(), false);
    }

    public getProcessId(): string {
        return this.processId;
    }

    public getType(): string {
        return this.type;
    }
    public getName(): string {
        return this.name;
    }

    public getStatus(): string {
        return this.status;
    }

    public getTable(): ProcessTableObject {
        return this.table;
    }

    public getDetails(): ProcessDetailsObject {
        return this.details;
    }

    public setDetails(details: ProcessDetailsObject): void {
        this.details = details;
    }

    public setTable(table: ProcessTableObject): void {
        this.table = table;
    }

    public isFetched() {
        return this.fetched;
    }
}



